import { LanguageService } from './../language.service';
import { PopoverController } from '@ionic/angular';
import { LanguageListComponent } from './../language-list/language-list.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent implements OnInit {

  constructor(private popoverController: PopoverController, private langService:LanguageService) { }

  imgSource: string;

  ngOnInit() {
    /**
     * Watch for any changes on app language
     */
    this.langService.langObs.subscribe((lang) => {
      this.imgSource = `./../../assets/images/flags/${lang}.png`;
    });
  }

  async onSwapLangBtnClicked(ev: any) {
    const popover = await this.popoverController.create({
      component: LanguageListComponent,
      event: ev,
      translucent: true,
      cssClass: 'app-popover-md'
    });
    await popover.present();
  }

}
